import { render } from "./CollectionHubView.vue?vue&type=template&id=b85153be"
import script from "./CollectionHubView.vue?vue&type=script&lang=js"
export * from "./CollectionHubView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__